import axios from '@/plugins/axiosInstance';
import { googleIntegration } from '@/networking/urlManager';
import { responseHandlerService } from '@/plugins/responseHandlerService';

/**
 * Kullanıcının sistemde mevcut bir Google hesabını yeniden eklemeye çalışıp
 * çalışmadığını kontrol eder. Eğer aynı hesap mevcutsa, kullanıcıya bilgi verilir.
 * 
 * @param {string} email - Kontrol edilecek Google hesabı e-posta adresi
 * @returns {Promise<boolean>} - Hesap zaten mevcut mu
 */
export const checkDuplicateAccount = async (email) => {
  try {
    if (!email) {
      console.error('Email parameter is required');
      return false;
    }
    
    // Mevcut hesapları getir
    const response = await axios.get(googleIntegration.accounts);
    const accounts = response.data.data || [];
    
    // Aynı e-posta adresine sahip hesap var mı kontrol et
    const duplicateAccount = accounts.find(
      account => account.account_identifier?.toLowerCase() === email.toLowerCase()
    );
    
    if (duplicateAccount) {
      responseHandlerService.handleInfo(
        `"${email}" hesabı zaten bağlı. Mevcut hesabı kullanabilir veya önce mevcut hesabın bağlantısını kesip tekrar ekleyebilirsiniz.`
      );
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Hesap kontrolü sırasında hata:', error);
    return false;
  }
};